
export function checkScrolledPosition() {
    if ($(window).scrollTop() > 0) {
        $('.header').addClass('header_scrolled')
    } else {
        $('.header').removeClass('header_scrolled')
    }
}
export function headerScrolled() {
    $(window).on('scroll', function () {
        checkScrolledPosition()
    })
}

export function toggleMobileMenu() {
    $('.trigger').on('click', function () {
        $(this).toggleClass('active')
        $('.sidebar-mobile').toggleClass('sidebar-mobile__show')
    })
}